const PASSWORD_VALIDATION = {
  MIN_LENGTH: 8,
};

export default PASSWORD_VALIDATION;
